import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'

export const FailureAcceptPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  const navigate = useNavigate()
  const { mid, mfid } = useParams()
  const [message, setMessage] = useState('Accepting failure...')

  useEffect(() => {
    if (!mid || !mfid) {
      setMessage('Invalid failure link.')
      return
    }
    services.session.fetchWithToken(`/api/communal/machines/byid/${mid}/failures/${mfid}/accept`, {
      method: 'POST'
    }).then((response) => {
      if (!response.ok) {
        throw new Error('accept failed')
      }
      navigate(`/communal/machine/${mid}/failures`, { replace: true })
    }).catch(() => {
      setMessage('Failed to accept failure.')
    })
  }, [mid, mfid])

  return <div className='spinner'>{message}</div>
}
